import { NgModule, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentType } from '@angular/cdk/portal';
import { RoutedDialogWrapperComponent } from './routed-dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ActivatedRoute, ActivatedRouteSnapshot, Route, RouterModule } from '@angular/router';
import { RoutedDialogWrapperService } from './routed-dialog.service';
import { DialogLinkDirective } from './dialog-link.directive';
import { NavigationDataService } from './navigation-data.service';
import { DialogLinkService } from './dialog-link.service';

export interface RoutedDialogRouteDataSupplied {
    id?: string;
    fullscreen?: boolean;
    backdropFullscreen?: boolean;
    nonModal?: boolean;
}
export interface RoutedDialogRouteData extends RoutedDialogRouteDataSupplied {
    id?: string;
    dialogComponent: ComponentType<IRoutedDialogComponent | any>;
    originalRoute?: {
        navigatedFromRoute: string;
    };
}

export interface RoutedDialogDialogData {
    route: ActivatedRouteSnapshot;
    route$: ActivatedRoute;
    routeData: RoutedDialogRouteData;
    close: () => void;
    maximize: () => void;
}

export interface IRoutedDialogComponent {
    contentTemplate: TemplateRef<any>;
}

export function makeRouteForDialog(
    path: string,
    dialogComponent: ComponentType<IRoutedDialogComponent | any>,
    options?: RoutedDialogRouteDataSupplied
): Route {
    const data: RoutedDialogRouteData = {
        ...(options || {}),
        dialogComponent,
    };

    return {
        path,
        component: RoutedDialogWrapperComponent,
        data,
        resolve: {
            originalRoute: RoutedDialogWrapperService,
        },
    };
}

@NgModule({
    declarations: [RoutedDialogWrapperComponent, DialogLinkDirective],
    imports: [CommonModule, MatDialogModule, RouterModule],
    exports: [RoutedDialogWrapperComponent, DialogLinkDirective],
    providers: [RoutedDialogWrapperService, NavigationDataService, DialogLinkService],
})
export class RoutedDialogWrapperModule {}
